export const removeLeadingZero = (str?: string) => {
  if (str && str.startsWith("0")) {
    return str.replace(/^0+/, "");
  }

  return str;
};
